import { render } from "./FairsView.vue?vue&type=template&id=706d4be6"
import script from "./FairsView.vue?vue&type=script&lang=js"
export * from "./FairsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__